import React from 'react';
import { ShieldCheckIcon, LockIcon, ZapIcon, CreditCardIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
const rows = [{
  label: '📘 The MenoReset System™ (6 Volumes, 60+ pages)',
  price: '$19'
}, {
  label: '🎁 Bonus #1: The Hormone-Balancing Elixirs',
  price: 'FREE'
}, {
  label: '🎁 Bonus #2: The 7-Day Meno-Detox Plan',
  price: 'FREE'
}, {
  label: '🎁 Bonus #3: The Meno-Apothecary Encyclopedia',
  price: 'FREE'
}, {
  label: '🛡️ 7-Day Money-Back Guarantee',
  price: 'INCLUDED'
}, {
  label: '♾️ Lifetime access & free updates',
  price: 'INCLUDED'
}];
const trust = [{
  icon: LockIcon,
  label: '100% Secure Payment'
}, {
  icon: ZapIcon,
  label: 'Instant Delivery'
}, {
  icon: ShieldCheckIcon,
  label: '7-Day Guarantee'
}, {
  icon: CreditCardIcon,
  label: 'Debit / Credit'
}];
export function ValueStack() {
  return <section id="value" aria-label="Offer summary" className="border-y border-grape/10 bg-white/70" data-id="element-189" data-mp="30wacdhef7o36">
      
    </section>;
}